import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { useQuery } from "@tanstack/react-query";
import { axiosget } from "../../helpers/httprequest";
import BtnGenerateRRR from "../BtnGenerateRRR";
import BtnPaymentGateway from "../BtnPaymentGateway";
import { FiCreditCard } from "react-icons/fi";

/**
 * Unified Payment Button
 * Shows either Remita (BtnGenerateRRR) or Clane/Other Gateway (BtnPaymentGateway)
 * based on which gateway is set as default
 */
const BtnUnifiedPayment = ({ inline = false, quickApplySessionId }) => {
    const [showModal, setShowModal] = useState(false);

    // Fetch default gateway
    const { data: gatewayData, isLoading } = useQuery({
        queryKey: ["defaultGateway"],
        queryFn: async () => {
            const res = await axiosget("ms_payments/gateway");
            return res?.data;
        },
        staleTime: 5 * 60 * 1000, // Cache for 5 minutes
    });

    const defaultGateway = gatewayData?.data?.name || "remita";

    return (
        <>
            {/* Render the appropriate payment component based on default gateway */}
            {defaultGateway === "remita" ? (
                <BtnGenerateRRR inline={inline} quickApplySessionId={quickApplySessionId} />
            ) : (
                <BtnPaymentGateway inline={inline} quickApplySessionId={quickApplySessionId} />
            )}
        </>
    );
};

export default BtnUnifiedPayment;
